import axios from "axios";
import { BASE_URL, getFileUrl } from "../../helper/constants";

// "Save" of the message menu (mobile ChatAction "Save": the album, documents, video or voice
// message to the device). The web downloads the files instead.

const absUrl = (path) => {
  const url = getFileUrl(path);
  if (!url) return "";
  if (/^(https?:|blob:|data:)/i.test(url)) return url;
  return BASE_URL + url;
};

const extOf = (url) => {
  const clean = String(url || "").split(/[?#]/)[0];
  const m = clean.match(/\.([a-z0-9]{1,6})$/i);
  return m ? m[1].toLowerCase() : "";
};

const fileNameFor = (url, name, fallbackBase) => {
  const ext = extOf(url);
  let base = String(name || "").trim();
  if (!base) {
    try {
      base = decodeURIComponent(String(url || "").split(/[?#]/)[0].split("/").pop() || "");
    } catch (_) {
      base = "";
    }
  }
  if (!base || /^blob:|^data:/i.test(base)) base = fallbackBase;
  if (ext && !base.toLowerCase().endsWith(`.${ext}`) && !/\.[a-z0-9]{2,5}$/i.test(base)) base = `${base}.${ext}`;
  return base;
};

/** [{ url, name }] of every file a message carries (album images, documents, video, voice). */
export function mediaFilesOf(chat) {
  const out = [];
  const push = (fileUrl, name) => {
    const url = absUrl(fileUrl);
    if (url && !out.some((f) => f.url === url)) out.push({ url, name: Array.isArray(name) ? name[0] : name });
  };
  if (!chat || chat.isDeleted) return out;
  const type = String(chat.messageType || "").toLowerCase();
  if (type === "image") {
    if (Array.isArray(chat.images) && chat.images.length) {
      chat.images.forEach((img) => push(img && (img.serverFileUrl || img.fileUrl), img && img.attachedFileName));
    } else {
      push(chat.serverFileUrl || chat.fileUrl, chat.attachedFileName);
    }
  } else if (type === "doc") {
    if (Array.isArray(chat.documents) && chat.documents.length) {
      chat.documents.forEach((d) => push(d && d.fileUrl, d && d.attachedFileName));
    } else {
      push(chat.fileUrl, chat.attachedFileName);
    }
  } else if (type === "video" || type === "audio") {
    push(chat.serverFileUrl || chat.fileUrl, chat.attachedFileName);
  }
  return out;
}

async function downloadOne(file, index) {
  const fileName = fileNameFor(file.url, file.name, `kjuup-${Date.now()}-${index + 1}`);
  const res = await axios({ url: file.url, method: "GET", responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}

/** Downloads every file of the message; resolves false when there was none or one failed. */
export default async function saveMessageMedia(chat) {
  const files = mediaFilesOf(chat);
  if (!files.length) return false;
  let ok = true;
  for (let i = 0; i < files.length; i += 1) {
    try {
      // one after the other: browsers block a burst of parallel downloads
      await downloadOne(files[i], i);
    } catch (_) {
      ok = false;
    }
  }
  return ok;
}
